import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmergingTalentCard = ({ talent }) => {
  return (
    <div className="bg-card rounded-lg border border-border overflow-hidden hover:shadow-lg transition-shadow duration-300">
      <div className="relative h-48 md:h-56 lg:h-64 overflow-hidden">
        <Image
          src={talent?.image}
          alt={talent?.imageAlt}
          className="w-full h-full object-cover"
        />
        <div className="absolute top-3 right-3">
          <span className="px-3 py-1 rounded-full text-xs font-medium bg-accent text-accent-foreground">
            Rising Star
          </span>
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-background/95 via-background/50 to-transparent" />
        <div className="absolute bottom-3 left-3 right-3">
          <h3 className="text-base md:text-lg font-bold text-white mb-1">{talent?.name}</h3>
          <p className="text-xs text-white/80">{talent?.position} • {talent?.age} years</p>
        </div>
      </div>
      <div className="p-4 md:p-5">
        <div className="flex items-center gap-2 mb-4">
          <Icon name="MapPin" size={14} color="var(--color-muted-foreground)" />
          <p className="text-xs md:text-sm text-muted-foreground">{talent?.currentClub} • {talent?.country}</p>
        </div>
        <div className="grid grid-cols-3 gap-3 mb-4">
          <div className="text-center">
            <p className="text-xs text-muted-foreground mb-1">Goals</p>
            <p className="text-lg md:text-xl font-bold text-foreground">{talent?.goals}</p>
          </div>
          <div className="text-center">
            <p className="text-xs text-muted-foreground mb-1">Assists</p>
            <p className="text-lg md:text-xl font-bold text-foreground">{talent?.assists}</p>
          </div>
          <div className="text-center">
            <p className="text-xs text-muted-foreground mb-1">Rating</p>
            <div className="flex items-center justify-center gap-1">
              <Icon name="Star" size={14} color="var(--color-warning)" />
              <p className="text-lg md:text-xl font-bold text-foreground">{talent?.rating}</p>
            </div>
          </div>
        </div>
        <div className="mb-4">
          <p className="text-xs text-muted-foreground mb-2">Market Value</p>
          <p className="text-xl md:text-2xl font-bold text-primary">{talent?.marketValue}</p>
        </div>
        <Button variant="default" size="sm" fullWidth iconName="TrendingUp" iconPosition="left">
          View Full Profile
        </Button>
      </div>
    </div>
  );
};

export default EmergingTalentCard;